import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectTenantsQueryItems } from '../../../../../redux/tenants/selector';
import { tenants } from '../../../../../redux/tenants/action';
import TenantComponent from '../components/tenant.component';

 
const Tenant= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectTenantsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [ selectedTenant, setSelectedTenant ] = useState<any>([])
 
  const fetchTenantById= ()=>{
    dispatch(tenants.query({
      url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/query`,
      entity:'tenants',
      jsonData:{
      Records: [
      {  
        "Id": parmas?.id      
      }
    ]
    }})).then(()=>{
      setIsQuery(true)
    })
  }


  const handleUpdateClick  = async (event: any) => {
    event.preventDefault();
     dispatch(tenants.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business/onboard-query-by-ids`,entity:'tenants',jsonData:{ 
    Records: [{
      "Context":{},
      "Message":
      {
          "Id": parmas?.id    
      }
    }
  ]
 
}})).then(()=>{
 
})
    }

  useEffect(
    () => {  
      if (parmas?.id > 0) {
        fetchTenantById()
        createColumnDefs()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }      
    },
    []
  )


  useEffect(
    () => {  
      if (isQuery) {
        setSelectedTenant(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
  const back=()=>{
    navigate('/management/platform-management/tenants')
  }
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name' },
      {
        field: 'Url', headerName: 'Url'
      }
  
    ]);
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
      <TenantComponent
      tenantsDetails={selectedTenant}
       back={back}
       columnDefs={columnDefs}
       rowData={selectedTenant?.BusinessChannels}
       handleUpdateClick={handleUpdateClick}
      />  
      }
    </>
  )
 
}
 
export default Tenant;